import { HelperContext } from "../../Helper/helper.context";

import ImgHelpAnalytic from '../../../images/help_context/window_aggregation.png';

export const AnalyticHelpContext = ({onClose}) => {
    return (
        <HelperContext 
        onClose={onClose}
        children={
            <div style={{position: "relative", flexGrow: 1}}>
                <div className="text-center">
                    <img src={ImgHelpAnalytic}/>
                </div>
            </div>
        }
    />    
)}